import { useEffect, useRef } from 'react'

import { TYPE_SCOPED_FIELDS, buildToolFormValues } from './tools.helpers'

/**
 * A Lookup's entity settings, source, instructions and URLs mean nothing to an Auto Capture
 * tool, and a form's fields mean nothing to a Lookup. Switching the type starts the other
 * type's settings from empty; switching back to the saved type restores what was saved.
 */
export const ResetConfigWhenTypeChanges = ({ type, saved, setFieldValue }) => {
  const previousType = useRef(type)
  useEffect(() => {
    if (previousType.current === type) {
      return
    }
    previousType.current = type
    const source =
      type === saved.type
        ? saved
        : buildToolFormValues(null, { agentOptions: [], playbookOptions: [] })
    TYPE_SCOPED_FIELDS.forEach((name) => setFieldValue(name, source[name]))
  }, [type])

  return null
}
